export interface BroadcastPort {
  postMessage: (message: unknown) => void;
  onmessage: ((event: MessageEvent) => void) | null;
  close: () => void;
}

export type ChannelFactory = () => BroadcastPort;

export const LOGOUT_BROADCAST_MESSAGE = 'logout';

const CHANNEL_NAME = 'ams-auth-logout';

function createNoopPort(): BroadcastPort {
  return {
    postMessage: () => undefined,
    onmessage: null,
    close: () => undefined,
  };
}

export function createLogoutBroadcastChannel(): BroadcastPort {
  try {
    return new BroadcastChannel(CHANNEL_NAME);
  } catch (error) {
    console.error('AMS auth failed to create the logout broadcast channel', error);
    return createNoopPort();
  }
}
